import { Button, type ButtonProps, type PolymorphicComponentProps } from "@mantine/core"
import Link from "next/link"

type TProps = PolymorphicComponentProps<typeof Link, ButtonProps> & { href?: string }

export function ButtonLink(props: TProps) {
  return <Button component={Link} variant="navy" size="xs" {...props} />
}
